// extracted by mini-css-extract-plugin
export var redoItem = "_ki-1";
export var redoTrigger = "_ki-0";